import { BOOLEAN_BYTES_PER_ELEMENT, BusMessage, MessageFactory } from "flavr-common";
export var MovementMode;
(function (MovementMode) {
    MovementMode[MovementMode["FirstPerson"] = 0] = "FirstPerson";
})(MovementMode || (MovementMode = {}));
/**
 * Requests the current movement settings.
 */
export class RequestMovementSettingsMessage extends BusMessage {
    get byteLength() {
        return (Uint32Array.BYTES_PER_ELEMENT + // navMashLayerId
            Uint32Array.BYTES_PER_ELEMENT + // headHeight
            Uint8Array.BYTES_PER_ELEMENT + // movementMode
            BOOLEAN_BYTES_PER_ELEMENT); // isFlying
    }
    constructor(params = {}) {
        super();
        this.params = params;
    }
    serialization(stream) {
        if (stream.isReading) {
            this.params = {};
        }
        this.params.navMashLayerId = stream.uint32Safe(this.params.navMashLayerId);
        this.params.headHeight = stream.uint32Safe(this.params.headHeight);
        this.params.movementMode = stream.uint8Safe(this.params.movementMode);
        this.params.canFly = stream.booleanSafe(this.params.canFly);
    }
    static is(msg) {
        return msg.type === RequestMovementSettingsMessage.typestatic;
    }
}
RequestMovementSettingsMessage.typestatic = "RequestMovementSettingsMessage";
RequestMovementSettingsMessage.subjectstatic = "general";
MessageFactory.register(RequestMovementSettingsMessage);
/**
 * Returns the current movement settings.
 */
export class ResponseMovementSettingsMessage extends BusMessage {
    get byteLength() {
        return (Uint32Array.BYTES_PER_ELEMENT + // navMashLayerId
            Uint8Array.BYTES_PER_ELEMENT + // movementMode
            BOOLEAN_BYTES_PER_ELEMENT + // isFlying
            Uint32Array.BYTES_PER_ELEMENT); // headHeight
    }
    constructor(navMashLayerId, movementMode, isFlying, headHeight) {
        super();
        this.navMashLayerId = navMashLayerId;
        this.movementMode = movementMode;
        this.isFlying = isFlying;
        this.headHeight = headHeight;
    }
    serialization(stream) {
        this.navMashLayerId = stream.uint32(this.navMashLayerId);
        this.movementMode = stream.uint8(this.movementMode);
        this.isFlying = stream.boolean(this.isFlying);
        this.headHeight = stream.uint32(this.headHeight);
    }
    static is(msg) {
        return msg.type === ResponseMovementSettingsMessage.typestatic;
    }
}
ResponseMovementSettingsMessage.typestatic = "ResponseMovementSettingsMessage";
ResponseMovementSettingsMessage.subjectstatic = "general";
MessageFactory.register(ResponseMovementSettingsMessage);
/**
 * Requests whether camera rotation should currently be active.
 */
export class RequestCamRotationActiveMessage extends BusMessage {
    get byteLength() {
        return BOOLEAN_BYTES_PER_ELEMENT; // isCamRotationActive
    }
    constructor(isActive) {
        super();
        this.isActive = isActive;
    }
    serialization(stream) {
        this.isActive = stream.boolean(this.isActive);
    }
    static is(msg) {
        return msg.type === RequestCamRotationActiveMessage.typestatic;
    }
}
RequestCamRotationActiveMessage.typestatic = "RequestCamRotationActiveMessage";
RequestCamRotationActiveMessage.subjectstatic = "general";
MessageFactory.register(RequestCamRotationActiveMessage);
